export default __webpack_public_path__ + "static/realWorldImg2-78139d98299bb2665a9be1db06c859aa.webp";